import React from 'react';

import addIcon from 'images/gift/add_icon.svg';
import giftIcon from 'images/gift/giftbox_icon.svg';

import Button from '@components/ButtonLegacy';
import { group_subscriptions_settings_path } from '@routes';

import styles from './styles.module.scss';

const PurchaseConfirmation = ({
  setCurrentFormStep,
  numberOfPurchases,
}: {
  setCurrentFormStep: (state: number) => void;
  numberOfPurchases?: number;
}) => {
  return (
    <div className={styles.confirmationContainer}>
      <img src={giftIcon} className={styles.giftIconConfirmation} alt="GiftIcon" />
      <div className={styles.confirmHeader}>
        You’ve given {numberOfPurchases}{' '}
        {numberOfPurchases > 1 ? 'gift subscriptions!' : 'gift subscription!'}
      </div>
      <div className={styles.confirmSubHeader}>
        Gift recipients will receive an invitation through email to confirm their subscription.
      </div>
      <Button onClick={() => setCurrentFormStep(0)} variant="link" className={styles.addNewBtn}>
        <>
          <img src={addIcon} />
          <span>Add New Subscriber(s)</span>
        </>
      </Button>
      <div className={styles.settingLink}>
        You can manage your gifts in the <a href={group_subscriptions_settings_path()}>settings</a>{' '}
        menu.
      </div>
    </div>
  );
};

export default PurchaseConfirmation;
